<template>
  <v-container v-if="!!value">
    <v-icon small v-if="value.state==='SUCCESS'" color="green" @click="onDetail(value)">mdi-check-decagram-outline
    </v-icon>
    <v-icon small v-if="value.state==='FAILURE'" color="red" @click="onDetail(value)">mdi-alert-decagram-outline</v-icon>
    <v-icon small v-if="value.state==='PENDING'" color="orange" @click="onDetail(value)">
      mdi-dots-hexagon
    </v-icon>
    <v-icon small v-if="value.state==='STARTED'" color="green" @click="onDetail(value)">
      mdi-dots-hexagon
    </v-icon>
    <v-dialog
        v-model="dialogItem"
        persistent
    >
      <BaseItem
          ref="BaseItem"
          :item-uid="itemUid"
          :subtract-height="subtractHeight"
          parentComponent="TaskTable"
          dto-detail-model="TaskDetailQueryDTO"
          dto-save-model="TaskSaveCommandDTO"
          store-name="TaskTable"
          :modal-dialog="true"
          @cancel="dialogItem=false"
          @save="function(editedItem) {$emit('save', editedItem)}"
          :readonly="false"
          :dialog="dialogItem"
      >
        <template v-slot:body="{editedItem, lockPage, instance, slotHeight, editedItemCommon}">
          <v-sheet class="mx-3 overflow-y-auto">
            <v-row>
              <v-col cols="6">
                <v-simple-table>
                  <template v-slot:default>
                    <tbody>
                    <tr>
                      <td>UID</td>
                      <td>{{ editedItem.uid }}</td>
                    </tr>
                    <tr>
                      <td>Source name</td>
                      <td>{{ editedItem.source_name }}</td>
                    </tr>
                    <tr>
                      <td>Source UID</td>
                      <td>{{ editedItem.source_uid }}</td>
                    </tr>
                    <tr>
                      <td>Source IP</td>
                      <td>{{ editedItem.source_ip }}</td>
                    </tr>
                    <tr>
                      <td>Consumer name</td>
                      <td>{{ editedItem.consumer_name }}</td>
                    </tr>
                    <tr>
                      <td>Args</td>
                      <td>{{ editedItem.args }}</td>
                    </tr>
                    <tr>
                      <td>Kwargs</td>
                      <td>
                        <v-textarea
                          :value="JSON.stringify(editedItem.kwargs)"
                          readonly
                          dense
                          rows="10"
                          >
                        </v-textarea>
                      </td>
                    </tr>
                    <tr>
                      <td>Created on</td>
                      <td>{{ editedItem.create_on }}</td>
                    </tr>
                    <tr>
                      <td>Run on</td>
                      <td>{{ editedItem.run_on }}</td>
                    </tr>
                    <tr>
                      <td>End on</td>
                      <td>{{ editedItem.end_on }}</td>
                    </tr>
                    <tr>
                      <td>Retry count</td>
                      <td>{{ editedItem.retry_count }}</td>
                    </tr>
                    <tr>
                      <td>Priority</td>
                      <td>{{ editedItem.priority }}</td>
                    </tr>
                    <tr>
                      <td>Expire</td>
                      <td>{{ editedItem.result_ex }}</td>
                    </tr>
                    <tr>
                      <td>State</td>
                      <td>{{ editedItem.state }}</td>
                    </tr>
                    <tr>
                      <td>Result</td>
                      <td>{{ editedItem.result }}</td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="6">
                <v-sheet :height="height - 190" class="py-3 overflow-y-auto overflow-x-auto">
                  <v-textarea
                      class="mx-3 px-3"
                      v-model="editedItem.error"
                      label="Error"
                      :disabled="false"
                      auto-grow
                      outlined
                  >
                    <v-card-title>Error</v-card-title>
                    {{ editedItem.error }}
                  </v-textarea>
                  <v-textarea
                      class="mx-3 px-3"
                      v-model="editedItem.exception_traceback"
                      label="Traceback"
                      :disabled="false"
                      auto-grow
                      outlined
                  >
                  </v-textarea>
                </v-sheet>
              </v-col>
            </v-row>
          </v-sheet>
        </template>
      </BaseItem>

    </v-dialog>
  </v-container>
</template>

<script>

import BaseItem from "@/components/Base/BaseItem";

export default {
  name: 'BaseTaskIcon',
  inheritAttrs: false,
  props: {
    value: {default: null},
    width: {default: 2},
    size: {default: 20},
    subtractHeight: {type: [Number], default: 240},
    height: {type: [Number], default: window.innerHeight},
    store_name: {type: [String], default: 'TaskTable'},
  },

  components: {
    BaseItem,
  },

  computed: {
    itemUid() {
      return this.childUid
    },
  },

  methods: {
    onDetail(item) {
      console.log('onDetail', item)
      this.childUid = item.uid
      this.dialogItem = true
    },
    onCancel() {
      this.dialogItem = false
      // this.itemUid = null
    },
    exception_traceback(editedItem) {
      if (!!editedItem && !!editedItem.exception_traceback)
        return editedItem.exception_traceback.replace('\n', '<br><br>')
    },
    error(editedItem) {
      if (!!editedItem && !!editedItem.error)
        return editedItem.error.replace('\n', '<br><br>')
    },

  },

  async mounted() {
  },

  data() {
    return {
      dialogItem: false,
      childUid: null,
    }
  }
}
</script>

<style scoped lang="scss">

</style>
